import CustomTooltip from '../../../shared/CustomTooltip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import {
    InputLabel,
    Skeleton,
    Typography,
    FormHelperText,
    Stack,
} from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useGetAllGuestsQuery } from '../../../../app/Slices/SevenDayApiSlice';
import FormMultiAutocomplete from '../../../shared/FormMultiAutocomplete';

const RestrictedAccess = () => {
    const { control } = useFormContext();
    const { data: allGuests, isLoading } = useGetAllGuestsQuery(`/guests`);

    const guestOptions = (allGuests ?? []).map((g: any) => ({
        value: { id: Number(g.id) },
        label: g.name,
    }));

    return (
        <fieldset>
            <Stack spacing={2}>
                <div>
                    <Typography component='legend' variant='h2'>
                        VIP Access (optional){' '}
                        <CustomTooltip
                            title={
                                <Typography>
                                    All guests will be the default and can
                                    reserve this experience unless you select
                                    individual guests. Those that are not
                                    selected WILL NOT see/book this experience.
                                </Typography>
                            }
                            placement='right'
                        >
                            <HelpOutlineIcon sx={{ fontSize: '16px' }} />
                        </CustomTooltip>
                    </Typography>
                    <Typography sx={{ color: 'text.secondary' }} gutterBottom>
                        Choose which VIP guests can view and reserve this
                        experience.
                    </Typography>
                </div>
                <div>
                    <InputLabel htmlFor='guests__input'>Guests</InputLabel>
                    {isLoading ? (
                        <>
                            <Skeleton
                                animation='wave'
                                width={400}
                                height={20}
                            />
                            <Skeleton
                                animation='wave'
                                width={400}
                                height={20}
                            />
                            <Skeleton
                                animation='wave'
                                width={400}
                                height={20}
                            />
                        </>
                    ) : (
                        <FormMultiAutocomplete
                            id='guests__input'
                            name='guests'
                            control={control}
                            options={guestOptions}
                            placeholder='All guests'
                        />
                    )}
                    <FormHelperText>
                        Leave empty to allow all guests
                    </FormHelperText>
                </div>
            </Stack>
        </fieldset>
    );
};

export default RestrictedAccess;
